import 'isomorphic-fetch';
import { globalErrorHandler } from '../utility/errorHandler';
import { showProgress } from '../errorhandler/actions/actions';
import { toast } from 'react-toastify';
import { createHashHistory } from 'history';

const fetchMiddleware = store => next => action => {
    if (!action || !action.fetchConfig) {
        return next(action);
    }

    const dispatch = store.dispatch;
    const config = action.fetchConfig;
    //const addd = action.fetchConfig;

    // copy everything except fetchConfig
    const clonedAction = JSON.parse(JSON.stringify(action));
    delete clonedAction['fetchConfig'];

    dispatch(clonedAction);
    const token = sessionStorage["msal.idtoken"];
    // Show progress
    if (config.showGlobalProgress) {
        dispatch(showProgress(true));
    }
    const jwttoken = "Bearer " + token;
    ////console.log(token);
    const path = config.address;
    const method = config.method || 'GET';
    // Create request headers
    let headers;
    if (!config.headers) {
        headers = new Headers({ '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value, 'Content-Type': 'application/json', 'Authorization': jwttoken });
        // headers = new Headers({ 'Content-Type': 'application/json' });
    }
    else if (!config.headers['Content-Type']) {
        headers = new Headers(Object.assign({}, config.headers, { 'Content-Type': 'application/json', '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value, 'Authorization': jwttoken }));
    }
    else {
        headers = new Headers(config.headers, { '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value, 'Authorization': jwttoken });
    }
    const body = config.body;
    const successHandler = config.success;
    const failureHandler = config.failure;

    // Add no cache header for all GET calls
    if (method === 'GET') {
        headers.append('Pragma', 'no-cache');
    }
    return fetch(path,
        {
            method: method,
            headers: headers,
            credentials: 'same-origin',
            body: JSON.stringify(body)
        })
        .then(response => {
            if (response.status === 401) {
                dispatch(showProgress(false));
                const hashHistory = createHashHistory();
                hashHistory.replace('/error');
            }
            else if (response.status !== 200) {
                throw new Error(response.status);
            }

            return response;
        })
        .then(response => {
            if (config.download) {
                response.blob().then(blob => {
                    var fileDownload = require('js-file-download');
                    fileDownload(blob, config.fileName + config.fileExtention);

                    // Hide progress
                    if (config.showGlobalProgress) {
                        dispatch(showProgress(false));
                    }
                })
            }
            else {
                response.json()
                    .then(globalErrorHandler)
                    .then(json => {
                        if (successHandler) {
                            if (typeof json === 'string' || json instanceof String) {
                                json = JSON.parse(json);

                            }
                            dispatch(successHandler(json));
                        }

                        // Hide progress
                        if (config.showGlobalProgress) {
                            dispatch(showProgress(false));
                        }
                    })
            }
        })
        .catch(error => {
            if (error.stack === "TypeError: Failed to fetch") {
                toast.error("Session expired, Please try logging in again", {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'message failed dam-msg-icon--error fa fa-times-circle',
                    toastId: "401"
                });
                window.location.reload();
            }
            else {
                toast.error("Some error occurred, Please try again", {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'message failed dam-msg-icon--error fa fa-times-circle',
                });
            }

            // Hide progress
            if (config.showGlobalProgress) {
                dispatch(showProgress(false));
            }

            if (failureHandler) {
                dispatch(failureHandler(error));
            }
        });
};

export default fetchMiddleware